export const getFileTypeDisplay = (mimeType) => {
  const [type, subtype] = mimeType.split('/');
  switch (type) {
    case 'audio':
      return subtype;
    case 'video':
      return subtype;
    case 'application':
      if (subtype.includes('pdf')) return 'PDF';
      if (subtype.includes('doc') || subtype.includes('word')) return 'Document';
      return 'File';
    default:
      return 'File';
  }
};
